.title {
    font-weight: 500;
    color: var(--grey);
    font-size: 30px;
    line-height: 1.5;
    font-family: 'Doyle';
}
